// node-modules
import DLAnimate from 'dl-animate/dist/dl-animate-module';

// assets
import './SeeMore.scss';

const defaults = {
  button: null,
  container: '[data-role="see-more-container"]',
  elements: '',
  countShowElements: 8,
};

export default class Tabs {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.button = options.button;
    this.container = this.button.closest(options.container);
    this.elements = Array.from(this.container.querySelectorAll(options.elements));
    this.countShowElements = options.countShowElements;
    this.animate = new DLAnimate();
    this.duration = document.documentElement.dataset.duration * 1000;

    this.init();
  }

  hideElements() {
    for (let i = this.countShowElements; i < this.elements.length; i += 1) {
      this.animate.hide(this.elements[i], {
        name: 'see-more',
        track: 'none',
        duration: this.duration,
      });
    }
  }

  showElements() {
    for (let i = this.countShowElements; i < this.elements.length; i += 1) {
      this.animate.show(this.elements[i], {
        name: 'see-more',
        track: 'none',
        duration: this.duration,
      });
    }
  }

  toggleStatus() {
    this.button.classList.toggle('is-opened');
    if (this.button.classList.contains('is-opened')) {
      this.showElements();
    } else {
      this.hideElements();
    }
  }

  init() {
    this.hideElements();
    this.button.addEventListener('click', this.toggleStatus.bind(this));
  }
}



// WEBPACK FOOTER //
// ./components/SeeMore/SeeMore.js